import {initialUnitMeasureState, unitMeasureAdapter} from "./unit-measure.state";
import { createReducer, on } from "@ngrx/store";
import { UnitMeasureActions } from "./unit-measure.actions";

export const unitMeasureReducer = createReducer(
    initialUnitMeasureState,
    on(UnitMeasureActions.loadUnitMeasureSuccess, (state, action) => {
        console.log('Unit of measure list:', action.unitMeasures);
        return unitMeasureAdapter.setAll(action.unitMeasures, {
            ...state,
            errorMessage: null
        });
    }),
    // on(ProjectTypeActions.addProjectTypeSuccess, (state, { projectType }) => {
    //     return projectTypeAdapter.addOne(projectType, {
    //         ...state,
    //         errorMessage: null
    //     });
    // }),
    // on(ProjectTypeActions.updateProjectTypeSuccess, (state, { projectType }) => {
    //     if (!projectType.projectTypeId) {
    //         return {
    //             ...state,
    //             errorMessage: "projectTypeId is required for update"
    //         };
    //     }
    //     return projectTypeAdapter.updateOne({ id: projectType.projectTypeId, changes: projectType }, {
    //         ...state,
    //         errorMessage: null
    //     });
    // }),
    // on(ProjectTypeActions.deleteProjectType, (state, { projectTypeId }) => {
    //     return projectTypeAdapter.removeOne(projectTypeId, {
    //         ...state,
    //         errorMessage: null
    //     });
    // }),
);